import previewVhost from './preview-vhost';

export default {
  previewVhost,
};
